































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AppsAppNoInstalledMalls } from 'ncp-api-supporter';
import { executeApp } from '@/components/header/gnbWrap';
import SelectBox from '@/pro/components/common/SelectBox.vue';

@Component({components: {  SelectBox }})
export default class MallSelectionModal extends Vue {
  @Prop() private appInstalledMalls: AppsAppNoInstalledMalls[] | null;
  @Prop() private closePopup: () => void;
  @Prop() private selectedAppNo: number;


  private selectedMallNo = 0;

  private initialOption = {
    id: 0,
    value: 0,
    name: '쇼핑몰을 선택해 주세요.',
  };

  private handleSelectMall(mallNo: number) {
    this.selectedMallNo = mallNo;
    const selectedMall = this.appInstalledMalls?.find(mall => mall.mallNo === mallNo);

    executeApp(this.selectedAppNo, selectedMall);
    this.closePopup();
  }

  private getMallName (mall: AppsAppNoInstalledMalls) {
    let mallName = `${mall.mallName}(${mall.mallNo})`;

    if (['SEPARATED_GLOBAL_MAIN', 'SEPARATED_GLOBAL_SUB'].includes(mall.globalMallType)) {
      mallName = `[글로벌${mall.globalMallType === 'SEPARATED_GLOBAL_MAIN' ? 'M' : 'S'}]` + mallName;
    }

    return mallName;
  }
}
